import React, { Component } from 'react';
import directory from '../resources/images/estrategas/tools/directory.png';
import news from '../resources/images/estrategas/tools/news.png';
import businessProcess from '../resources/images/estrategas/tools/businessProcess.png';
import { Link } from 'react-router-dom';
import quality from '../resources/images/estrategas/tools/quality.svg';
import conctactCenter from '../resources/images/estrategas/tools/management.svg';
import talent from '../resources/images/estrategas/tools/talent.svg';
import newBusiness from '../resources/images/estrategas/tools/newBusiness.jpg';
import cartography from '../resources/images/estrategas/tools/cartography.svg'


class CorporateTools extends Component {
  constructor(props) {
    super(props);
    let userData = JSON.parse(localStorage.getItem('userData'));
    this.state = { userData: userData };
  }

  render() {
    let talentModule = (this.state.userData.rol === 'direction') ? <div className="col-md-4 col-3">
      <Link to={'/human-resources'}>
        <div className="product-single tool pl-0 pr-0"
             style={{
               boxShadow: 'none',
               marginBottom: '0px!important'
             }}>
          <img src={talent} alt=" " className="imgStyle"/>
          <h5>Talento</h5>
        </div>
      </Link>
    </div> : '';
    return (<div className='row'>
        <div className="col-md-4 col-3">
          <Link to={'/directory'}>
            <div className="product-single tool pl-0 pr-0"
                 style={{
                   boxShadow: 'none',
                   marginBottom: '0px!important'
                 }}>
              <img src={directory} alt=" " className="imgStyle"/>
              <h5>Directorio</h5>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-3">
          <Link to={'/news'}>
            <div className="product-single tool pl-0 pr-0"
                 style={{ boxShadow: 'none' }}>
              <img src={news} alt=" " className="imgStyle"/>
              <h5>Novedades Estrategas</h5>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-3">
          <a href="https://implementta.net/modelodegestion/GST000008.htm">
            <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
              <img src={businessProcess} alt=" " className="imgStyle"/>
              <h5>Procesos de Negocio</h5>
            </div>
          </a>
        </div>
        <div className="col-md-4 col-3">
          <Link to={'/quality'}>
            <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
              <img src={quality} alt=" " className="imgStyle"/>
              <h5>Calidad</h5>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-3">
          {/*<Link to={'/contact-center'}>*/}
          <a href='https://app.powerbi.com/view?r=eyJrIjoiYWY5YTEyOTMtNmJjNC00YmEyLTk0MzEtYmY1Y2IxMGYzZDExIiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9' target='_blank'>
            <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
              <img src={conctactCenter} alt=" " className="imgStyle"/>
              <h5>Sistemas</h5>
            </div>
          </a>
          {/*</Link>*/}
        </div>
        {talentModule}
        <div className="col-md-4 col-3">
          <Link to={'/new-business'}>
            <div className="product-single tool pl-0 pr-0"
                 style={{
                   boxShadow: 'none',
                   marginBottom: '0px!important'
                 }}>
              <img src={newBusiness} alt=" " className="imgStyle"/>
              <h5>Nuevos negocios</h5>
            </div>
          </Link>
        </div>
        <div className="col-md-4 col-3">
          {/*<Link to={'/contact-center'}>*/}
          <a href='https://app.powerbi.com/view?r=eyJrIjoiYTAzN2E5ZDEtOGRlMi00NWY5LTgxOWYtMGNmMjk0ZjJlNTQ2IiwidCI6IjM3MjliZThjLTFlYjEtNDRmMS05ZmQ0LWNlZGRiMjA0NjYzZSJ9&fbclid=IwAR3gPjaU6455BxilTAPzU63q0v5EJlHQxaG_098QpvNFdE0HeKh3WIiVS7Y' target={'blank'}>
            <div className="product-single tool pl-0 pr-0" style={{ boxShadow: 'none' }}>
              <img src={cartography} alt=" " className="imgStyle"/>
              <h5>Cartografía</h5>
            </div>
          </a>
          {/*</Link>*/}
        </div>
      </div>
    );
  }
}

export default CorporateTools;



// WEBPACK FOOTER //
// ./src/components/corporateTools.js